var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.003,
    height: 17,
    viewBox: "0 0 18.003 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.56,8.94,7.62,0,6.21,1.41,8.59,3.79,3.44,8.94a1.491,1.491,0,0,0,0,2.12l5.5,5.5a1.5,1.5,0,0,0,2.12,0l5.5-5.5a1.491,1.491,0,0,0,0-2.12ZM5.21,10,10,5.21,14.79,10ZM19,11.5s-2,2.17-2,3.5a2,2,0,0,0,4,0C21,13.67,19,11.5,19,11.5Z",
    transform: "translate(-2.998)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillColor);
export default __webpack_public_path__ + "static/media/fill_color.befde7610e5e915236eae6465c9a60f7.svg";
export { ForwardRef as ReactComponent };